<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiUndoVariant } from "@mdi/js";
export default {
  name: "MdiUndoVariant",
  data() {
    return {
      svgPath: mdiUndoVariant,
    };
  },
};
</script>
